import { gql } from "@apollo/client";

export const GET_ALL_ESTADO_COMERCIAL = gql`
    query getAllEstadoComercial{
        allEstadoCondicionalComercial
        {
            idEstadoCondicionalComercial,
            descripcion,
            codigo
        }
 }
`;